import {
  PhysicalSamplingConfig,
  ProductOptionRequirement,
  ProductOptionSource,
  ProductSelectionDraft,
  ProductSelectionValidationIssue
} from './types';

export const validateProductSelectionDraft = (
  config: PhysicalSamplingConfig,
  draft: ProductSelectionDraft
): ProductSelectionValidationIssue[] => {
  if (config.isUnsupported) return [{ code: 'UNSUPPORTED_CONFIG' }];
  const issues: ProductSelectionValidationIssue[] = [];
  const uniqueProductIds = Array.from(new Set(draft.selectedProductIds));
  if (
    uniqueProductIds.length < 1 ||
    uniqueProductIds.length > config.maxSelectableProducts
  ) {
    issues.push({
      code: 'INVALID_SELECTION_COUNT'
    });
  }

  uniqueProductIds.forEach((productId) => {
    const product = config.products.find((item) => item.id === productId);
    if (!product) {
      issues.push({ code: 'UNKNOWN_PRODUCT', productId });
      return;
    }
    if (product.optionRequirement !== ProductOptionRequirement.REQUIRED) return;
    const draftValue = draft.valuesByProductId[productId];
    if (product.optionSource === ProductOptionSource.PRODUCT_PAGE) {
      if (!draftValue?.productPageSelection.trim()) {
        issues.push({
          code: 'REQUIRED_PRODUCT_PAGE_SELECTION',
          productId
        });
      }
      return;
    }

    product.options.forEach((option) => {
      const value = draftValue?.optionSelections[option.id]?.trim() ?? '';
      if (!value) {
        issues.push({
          code: 'REQUIRED_OPTION',
          productId,
          optionId: option.id
        });
        return;
      }
      if (
        option.allowedValues.length > 0 &&
        !option.allowedValues.includes(value)
      ) {
        issues.push({
          code: 'INVALID_OPTION_VALUE',
          productId,
          optionId: option.id
        });
      }
    });
  });

  return issues;
};
